<script setup>
import {ref} from 'vue';
import axios from 'axios';

const props = defineProps({
    productId: {
        required: true,
        type: Number,
    },
    redirectToCart: {
        required: false,
        type: Boolean,
        default: false,
    },
});

const isLoading = ref(false);

const addToCart = async () => {
    isLoading.value = true;

    try {
        const response = await axios.post('/api/checkout/cart', {
            product_id: props.productId,
            quantity: 1,
        });

        const result = response.data;

        // Show success message
        if (window.app && window.app.$toast) {
            window.app.$toast.success(result.message || 'Produit ajouté au panier');
        }

        // Redirect to cart page if redirectToCart prop is true
        if (props.redirectToCart) {
            window.location.href = '/checkout/cart';
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Une erreur est survenue lors de l\'ajout au panier';

        if (window.app && window.app.$toast) {
            window.app.$toast.error(errorMessage);
        } else {
            console.error(error);
        }
    } finally {
        isLoading.value = false;
    }
};
</script>

<template>
    <button
        class="btn btn-primary"
        @click.prevent="addToCart"
        :disabled="isLoading"
    >
        <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        {{ isLoading ? 'Ajout en cours...' : 'Ajouter au panier' }}
    </button>
</template>

<style scoped>
button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}
</style>
